import { Box, Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Theme, Typography, useTheme } from "@mui/material";
import DocumentUpload from "../../../lib/formik/DocumentUpload";
import MFSelectField from "../../../lib/formik/SelectField";
import { DialogCloseIcon } from "../../../assets/SvgIcons";
import { FormikContextType, useFormikContext } from "formik";
import { initialDocument } from "../CreateJointHolder";
import { useState } from "react";
import React from "react";
import { SearchableSelect } from "../../../lib/formik/searchSelectField";
import { FileUpload } from "../../investors/documentDetails";
import { getFieldTitle } from "../../ApplicationDetails/DocumentDetails";


export default function DocumentUploadPopup({
    open,
    onClose,
}: {
    open: boolean;
    onClose: () => void;
    handleSubmit?: () => void,
}): JSX.Element {
    const {
        values,
        setFieldValue,
    }: FormikContextType<Record<string, any>> = useFormikContext();
    const [documentUpload, setDocumentUpload] = useState<boolean>(false);
    const handleDocumentUploadStart = () => {
        setDocumentUpload(true);
    };
    const handleDocumentUploadEnd = () => {
        setDocumentUpload(false);
    };
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            maxWidth='lg'
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '25px',
                    backgroundColor: theme.palette.common.white,
                    padding: "10px",
                    width: "80dvw",
                    // width: documentTypeValue == '' ? '1063px' : '600px',
                    maxHeight: "80%"
                },
            })}
            keepMounted
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    padding: "10px"
                }}
            >
                <Box>
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary,
                        })}
                    >
                        Document Upload
                    </Typography>
                </Box>
                <IconButton
                    aria-label="dialog-close"
                    onClick={onClose}
                    sx={{
                        padding: "5px",
                        "&:disabled": {
                            opacity: 0.5
                        }
                    }}
                // disabled={isDocumentLoading}
                >
                    <DialogCloseIcon />
                </IconButton>
            </Box>
            <DialogContent
                sx={{
                    maxHeight: "100%",
                    overflowY: "auto",
                    padding: "10px 20px 10px 10px"
                }}
            >
                <Box
                    sx={{
                        marginTop: "25px",
                        display: "flex",
                        flexDirection: 'column',
                        rowGap: "25px",
                    }}
                >
                    {/*pelo here  */}
                    {values.documents?.map((doc: initialDocument, docIndex: number) => {
                        const { documentType, options, documentId, disabled, minFileSize, maxFileSize, maxFiles, uploadFormats, multipleFiles, required, documentName, url } = doc;
                        if (`${disabled}` == 'true') return null;
                        return (
                            <Grid key={`mainFrag-${docIndex}`} container sx={{ border: `1px solid ${theme.palette.text.secondary}`, borderRadius: '10px', display: 'flex', flexDirection: 'row', padding: '20px', gap: '10px', justifyContent: 'space-between' }}>
                                <Grid
                                    item
                                    xs={12}
                                    lg={6}
                                    sx={{ '& .MuiGrid-item': { paddingTop: '0 !important' } }}
                                >
                                    <Typography variant="body_500" sx={{ color: 'text.primary' }}>{getFieldTitle[documentType]}{(`${required}` == 'true') ? '*' : ''}</Typography>
                                    {options?.length > 0 &&
                                        <Grid xs={12} sm={12} sx={{ paddingTop: '0', padding: '0' }}>
                                            <SearchableSelect
                                                name={`documents.${docIndex}.documentName`}
                                                label={documentName}
                                                items={options?.map((item: string) => ({
                                                    key: item,
                                                    value: item,
                                                }))}
                                                // applyLabelStyles={true}
                                                disabled={disabled}
                                            />
                                        </Grid>
                                    }
                                    {url && (
                                        <Button
                                            variant="contained"
                                            sx={{ p: 0.8, mt: 1 }}
                                            onClick={() => window.open(`${window.location.origin}` + url, '_blank')}
                                        >
                                            <Typography variant='overline_400'>Download {documentName}</Typography>
                                        </Button>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    lg={5}
                                >
                                    <React.Fragment key={docIndex}>
                                        <FileUpload
                                            onFileChange={(value, documentId, removeFile) => {
                                                const { file, ...rest } =
                                                    values.documents[docIndex];
                                                setFieldValue(
                                                    `documents.${docIndex}`,
                                                    {
                                                        ...rest,
                                                        documentId,
                                                        ...(!removeFile && { file }),
                                                    }
                                                );
                                            }}
                                            name={`documents.${docIndex}.documentId`}
                                            documentData={doc}
                                            disabled={disabled ?? false}
                                            onFileUpload={handleDocumentUploadStart}
                                            onFileUploaded={handleDocumentUploadEnd}
                                            fileUploadFormats={uploadFormats}
                                            maxUploadFiles={maxFiles}
                                            maxFileSize={maxFileSize}
                                            minFileSize={minFileSize}
                                            multipleFilesCheck={multipleFiles}
                                        >
                                        </FileUpload>
                                    </React.Fragment>
                                </Grid >
                            </Grid>
                        )
                    })}
                </Box>
            </DialogContent>
            <DialogActions
                sx={{ justifyContent: "center" }}
            >
                <Button
                    variant="contained"
                    sx={(theme: Theme) => ({
                        ...theme.typography.body_600,
                        padding: "10px",
                        width: "50%"
                    })}
                    // disabled={values.documents?.every}
                    onClick={onClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog >
    )
}
